<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { useContactLaunchers } from '@hooks/support/contact-launchers.hook'

import amplitudeConfig from '@config/amplitude.json'
import { getContacts } from '@config/support'

import { trackEvent } from '@tools/amplitude'

defineOptions({
  name: 'LinkSendEmail',
})

const text = 'Send email'
const contacts = getContacts()

const {
  openEmail,
} = useContactLaunchers()

const setSubmit = (): void => {
  const options = {
    to: contacts.email,
    subject: 'Support request',
    body: '',
  }
  trackEvent(amplitudeConfig.events.clickLink, {
    name: 'link_send_email',
    link_text: text,
    ...options,
  })
  openEmail(options)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="envelope"
        size="md"
        color="default"
      />
    </template>
  </DropdownItem>
</template>
